var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Links"),_c('br'),_vm._v(" それぞれのブログ、販売サイトを記載予定。しばしお待ちを。 ")])}]

export { render, staticRenderFns }